import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["header", "layout", "scroller"]

  connect() {
    this.updateHeaderHeight()
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onHeaderChanged = this.onHeaderChanged.bind(this)
    this.scrollerTarget.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize)
    document.addEventListener("newsletter-editor-header:changed", this.onHeaderChanged)
    this.onScroll()
  }

  disconnect() {
    this.scrollerTarget.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
    document.removeEventListener("newsletter-editor-header:changed", this.onHeaderChanged)
  }

  onScroll() {
    this.setHidden(this.scrollerTarget.scrollTop > 8)
  }

  onResize() {
    this.updateHeaderHeight()
    this.onScroll()
  }

  onHeaderChanged() {
    requestAnimationFrame(() => {
      this.hidden = undefined
      this.updateHeaderHeight()
      this.onScroll()
    })
  }

  updateHeaderHeight() {
    this.headerHeight = this.headerTarget.offsetHeight
    this.headerTarget.style.transition = "transform 180ms ease, opacity 180ms ease, margin-bottom 180ms ease"
    this.headerTarget.style.willChange = "transform, opacity, margin-bottom"
    this.layoutTarget.style.transition = "height 180ms ease"
    this.layoutTarget.style.height = `calc(100vh - ${this.headerHeight}px)`
  }

  setHidden(hidden) {
    if (hidden === this.hidden) return

    this.hidden = hidden
    this.headerTarget.style.transform = hidden ? `translateY(-${this.headerHeight}px)` : "translateY(0)"
    this.headerTarget.style.opacity = hidden ? "0" : "1"
    this.headerTarget.style.marginBottom = hidden ? `-${this.headerHeight}px` : "0"
    this.layoutTarget.style.height = hidden ? "100vh" : `calc(100vh - ${this.headerHeight}px)`
  }
}
